import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Karim",
    job: "Plombier chauffagiste",
    zone: "Île-de-France",
    quote:
      "Je passais 3 heures par semaine sur mes devis et mes factures. Maintenant c'est géré. J'ai pris deux chantiers de plus ce mois-ci.",
    avatar:
      "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMG9mJTIwcGx1bWJlciUyMHdvcmtpbmd8ZW58MHx8fHwxNzgwOTkzMzYwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Sylvie",
    job: "Peintre en bâtiment",
    zone: "Lyon",
    quote:
      "Les relances impayés c'était ma bête noire. J'avais honte de rappeler mes clients. Maintenant c'est fait de façon professionnelle, et ça rentre.",
    avatar:
      "https://images.unsplash.com/photo-1528545027322-5e3b3f441730?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMG9mJTIwZmVtYWxlJTIwaG91c2UlMjBwYWludGVyfGVufDB8fHx8MTc4MDk5MzM2MHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Thierry",
    job: "Électricien indépendant",
    zone: "Bordeaux",
    quote:
      "J'ai testé la formule Essentielle le premier mois. Dès la deuxième semaine j'ai vu la différence. J'ai pas hésité à passer en Sérénité.",
    avatar:
      "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA5OTMzNjB8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      id="temoignages"
      data-testid="testimonials-section"
      className="bg-white py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <span className="inline-block text-[#E8611A] font-semibold text-sm tracking-widest uppercase mb-4">
            Témoignages
          </span>
          <h2 className="font-display font-extrabold text-[#1A2E4A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Ils ont récupéré leur temps
          </h2>
        </div>

        <div className="mt-14 sm:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="reveal group relative bg-[#F5F0EB] border border-black/5 rounded-sm p-7 sm:p-8 flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <Quote
                className="absolute top-6 right-6 w-8 h-8 text-[#E8611A]/20"
                strokeWidth={2}
              />
              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, k) => (
                  <Star
                    key={k}
                    className="w-4 h-4 text-[#E8611A] fill-[#E8611A]"
                    strokeWidth={0}
                  />
                ))}
              </div>
              <p className="text-[#2D2D2D] text-base leading-relaxed flex-1">
                «&nbsp;{r.quote}&nbsp;»
              </p>
              <div className="mt-7 pt-5 border-t border-black/10 flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={`${r.name}, ${r.job}`}
                  className="w-12 h-12 rounded-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                />
                <div>
                  <div className="font-display font-bold text-[#1A2E4A] text-base">
                    {r.name}
                  </div>
                  <div className="text-[#8A8A8A] text-xs">
                    {r.job} · {r.zone}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
